import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { Notification } from '../../models/notification.model';

import { LanguageProvider } from '../../providers/language/language';
import { NotificationProvider } from '../../providers/notification/notification';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-notifications',
  templateUrl: 'notifications.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class NotificationsPage {

  content: string;
  err: string;
  loading: boolean;

  showBackBtn: boolean = false;

  notifications: Notification[];

  dateLocale: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, public languageProvider:LanguageProvider, public notificationProvider: NotificationProvider) {
    this.dateLocale = this.languageProvider.getByLocale(this.translate.currentLang).code;

    if (this.navParams.get('showBackBtn')) {
      this.showBackBtn = true;
    }
  }

  closeModal() {
    this.navCtrl.pop();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  readAll() {
    this.notificationProvider.readAll().subscribe(
      res => this.viewCtrl.dismiss(),
      error => this.viewCtrl.dismiss()
    );
  }

  ionViewDidLoad() {
    this.notificationProvider.notifications.subscribe(
      (notifications: Notification[]) => this.notifications = notifications,
      error => this.viewCtrl.dismiss()
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts